module.exports = __webpack_public_path__ + "img/category-new-released.629a7e05.png";